import { useLayoutEffect, type RefObject } from 'react';

function fitHeight(node: HTMLTextAreaElement) {
  node.style.height = 'auto';
  node.style.height = `${String(node.scrollHeight)}px`;
}

/**
 * Lets a text area grow with what is written in it, up to the `max-height` its stylesheet sets,
 * after which it scrolls. Measured before paint on every change of the value and whenever the
 * field's width changes, so a long prompt never ends up squeezed into the starting two lines.
 */
export function useAutoGrow(field: RefObject<HTMLTextAreaElement | null>, value: string) {
  useLayoutEffect(() => {
    const node = field.current;
    if (node === null) return undefined;
    let width = node.clientWidth;
    fitHeight(node);
    if (typeof ResizeObserver === 'undefined') return undefined;
    const observer = new ResizeObserver(() => {
      if (node.clientWidth === width) return;
      width = node.clientWidth;
      fitHeight(node);
    });
    observer.observe(node);
    return () => {
      observer.disconnect();
    };
  }, [field, value]);
}
